import { render, staticRenderFns } from "./NewsAppStatistics.vue?vue&type=template&id=2d4b7310"
import script from "./NewsAppStatistics.js?vue&type=script&lang=js&external"
export * from "./NewsAppStatistics.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports